import React, { useState } from "react";
import Input from "../../../../../app/components/Input";
import Button from "../../../../../app/components/Button";

const General = () => {
    const [generalData, setGeneralData] = useState({
        nome: '',
        dominio: '',
        certificado: null,
        cnpj: '',
        razaoSocial: '',
        inscricaoEstadual: '',
        inscricaoMunicipal: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cep: '',
        cidade: '',
        estado: '',
        responsavel: '',
        telefone: '',
        email: '',
    })
    const [imageMessage, setImageMessage] = useState('');


    const handleChange = (eOrValue, fieldName) => {
        if (fieldName === 'certificado') {
            const file = eOrValue.target.files[0] || null;
            setGeneralData(prev => ({ ...prev, [fieldName]: file }));
            if (file && file.type.startsWith('image/')) {
              setImageMessage('Imagem carregada com sucesso!');
            } else {
              setImageMessage('');
            }
            return;
          }
        
          if (typeof eOrValue === 'object' && eOrValue !== null && 'value' in eOrValue) {
            setGeneralData(prev => ({
              ...prev,
              [fieldName]: eOrValue.value,
            }));
          } else {
            const { name, value } = eOrValue.target;
            setGeneralData(prev => ({
              ...prev,
              [name]: value,
            }));
          }   
    }

    return(
        <div>
            <h2 class="text-lg font-medium text-gray-900 pt-4">Informações Gerais</h2>
            <div className="grid grid-cols-2 gap-4 mt-7">
              <div className="col-span-2">
                  <Input 
                  label='Certificado'
                  type="file"
                  name='certificado'
                  value={generalData.certificado}
                  onChange={handleChange}
                  />
              </div>
                <Input 
                label='Nome'
                name='nome'
                value={generalData.nome}
                onChange={handleChange}
                />
                <Input 
                label='Domínio'
                name='dominio'
                value={generalData.dominio}
                onChange={handleChange}
                />
                <Input 
                label='CNPJ'
                name='cnpj'
                value={generalData.cnpj}
                onChange={handleChange}
                />
                <Input 
                label='Razão social'
                name='razaoSocial'
                value={generalData.razaoSocial}
                onChange={handleChange}
                />
                <Input 
                label='Incrição Estadual'
                name='inscricaoEstadual'
                value={generalData.inscricaoEstadual}
                onChange={handleChange}
                />
                <Input 
                label='Inscrição Municipal'
                name='inscricaoMunicipal'
                value={generalData.inscricaoMunicipal}
                onChange={handleChange}
                />
                <h2 class="text-lg font-medium text-gray-900 pt-1 col-span-2">Endereço</h2>
                <div className="col-span-2 grid grid-cols-3 mt-4 gap-4">
                  <div
                    className="col-span-3"
                  >
                      <Input 
                      label='Endereço'
                      name='endereco'
                      value={generalData.endereco}
                      onChange={handleChange}
                      />
                  </div>
                    <Input 
                    label='Número'
                    name='numero'
                    value={generalData.numero}
                    onChange={handleChange}
                    />
                    <Input 
                    label='Complemento'
                    name='complemento'
                    value={generalData.complemento}
                    onChange={handleChange}
                    />
                    <Input 
                    label='Bairro'
                    name='bairro'
                    value={generalData.bairro}
                    onChange={handleChange}
                    />
                    <Input 
                    label='CEP'
                    name='cep'
                    value={generalData.cep}
                    onChange={handleChange}
                    />
                    <Input 
                    label='Cidade'
                    name='cidade'
                    value={generalData.cidade}
                    onChange={handleChange}
                    />
                    <Input 
                    label='Estado'
                    name='estado'
                    value={generalData.estado}
                    onChange={handleChange}
                    />
                  </div>
                  <h2 class="text-lg font-medium text-gray-900 pt-1">Contatos</h2>
                  <div className="col-span-2 grid grid-cols-3 mt-4 gap-4">
                    <Input 
                    label='Nome Responsável'
                    name='responsavel'
                    value={generalData.responsavel}
                    onChange={handleChange}
                    />
                    <Input 
                    label='Telefone'
                    name='telefone'
                    value={generalData.telefone}
                    onChange={handleChange}
                    />
                    <Input 
                    label='Email'
                    name='email'
                    value={generalData.email}
                    onChange={handleChange}
                    />
                  </div>
            </div> 
            <div className="flex gap-4 mb-8 mt-4">
                <Button variant="primary">Salvar</Button>
                <Button variant="secondary">Cancelar</Button>
            </div>
        </div>
    )
}

export default General